<ng-container *transloco="let t">
    @if (competitor) {
    <div class="d-flex flex-column fs-14 grey-neutral-600" [ngClass]="{ 'competitor-item-mobile': true }" [ngStyle]="{
         'border-bottom': isLast ? 'none' : '1px solid var(--teal-200)',
         'padding-top': '16px',
         'padding-bottom': isAdmin ? '0' : '16px'
       }" (click)="openDetailsModal()">
        <div class="d-flex flex-row align-items-center justify-content-between pb-2">
            <div class="d-flex flex-row align-items-center">
                  <span class="badge rounded-pill me-2 result-badge-mobile">
          {{competitor | rank:category:gender:measurementType:false:true}}
        </span>
                <span class="fw-medium">
                  @if (Array.isArray(competitor?.competitorResultsDetail?.team) &&
                        competitor!.competitorResultsDetail!.team!.length > 0) {
                    {{(competitor?.lastName ?? "")| titlecase}}
              } @else {
                    {{
                    ((competitor?.firstName ?? "")| titlecase) + " " + ((competitor?.lastName
                      ?? "") | titlecase)
                          }}
                        }
          </span>
            </div>
            <div class="d-inline-flex">
          <span class="pe-3">
              @if (isRound) {
              <span>
                        {{t("measurements.controlpoints.lap")}}
                        {{competitor.competitorResultsDetail | nmControlPointsOrLaps:true}}
                    </span>
              }
              @else {
              {{
              competitor.competitorResultsDetail |resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType
                 }}
              }
          </span>
                <span class="cursor-pointer">
            <img src="assets/icons/icons-alt/chevron-circle.svg" alt="Open details"/>
          </span>
            </div>
        </div>

        <div class="d-flex flex-wrap align-items-center">
            <span class="fw-medium me-1">{{t("competitor.table.status.BIB")}}</span>
            <span>{{competitor.startNumber}}</span>
            @if (isTeam) {
            <div class="item-separator"></div>
             @for (member of competitor?.competitorResultsDetail?.team;track member;let lastMember = $last) {
            {{
            ((member?.fn ?? "") | titlecase) + " " + ((member?.ln ?? "") | titlecase)
            }}
            @if (member.sx) {
            <span>{{', '}}{{t("app.common.gender.short." + member.sx)}}</span>
            }
            @if (member.cty) {
            <span>{{', '}}{{member.cty | country:'iocCode' }}</span>
            }
            @if (!lastMember) {
            <div class="item-separator"></div>
            }
            }
            }
            @else {
            <div class="item-separator"></div>
                <span>{{t("app.common.gender.short." + competitor.sex)}}</span>
            }

            @if (!isTeam && competitor.country) {
            <div class="item-separator"></div>
            <span>{{competitor.country}}</span>
            }
            @if (competitor.club) {
            <div class="item-separator"></div>
            <span>{{competitor.club}}</span>
            }
        </div>

        <div class="d-flex flex-wrap align-items-center">
            <!--        LTP -->
            @if (isRound) {
            <span class="fw-medium me-1">
                {{ race?.raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED ?
                    t("competitor.table.distance") : t("competitor.table.time")
                }}
            </span>
             <span>
            {{ race?.raceSettings?.resultProcessingType === ResultProcessingType.TIME_LIMITED ?
                 (competitor.competitorResultsDetail?.distance | raceLengthFormat:undefined:"m") :
                 (competitor.competitorResultsDetail |resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType)
                 }}
            </span>
            }
            @else if (competitor?.competitorResultsDetail | ltpCompetitorStageDetail) {
            <span class="fw-medium me-1">LTP</span>
              <span>{{(competitor?.competitorResultsDetail | ltpCompetitorStageDetail)|waypointNameByWaypointId}}</span>
            }

            @if ((isRound || (competitor?.competitorResultsDetail | ltpCompetitorStageDetail)) && competitor.categoryLabel) {
            <div class="item-separator"></div>
            }

            @if (competitor.category) {
            <span class="fw-medium me-1">{{t("app.common.category.short")}}</span>
            <span class="text-uppercase">{{competitor.categoryLabel}}</span>
            }
        </div>
    </div>
    }
</ng-container>